/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { clearSigningOutGate } from '@app/constants/signOutGate';

const initialState = {
  initialDataAlreadyFetched: false,
  isInitialDataLoading: false,
  isLdUserIdentified: false,
  shouldNavigateToAuthFailure: false,
};

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    fetchInitialDataRequest: state => {
      state.isInitialDataLoading = true;
    },

    fetchInitialDataSuccess: state => {
      clearSigningOutGate();
      state.isInitialDataLoading = false;
      state.initialDataAlreadyFetched = true;
      state.isLdUserIdentified = true;
    },
    fetchInitialDataError: (state, { payload }) => {
      clearSigningOutGate();
      state.isInitialDataLoading = false;
      state.initialDataAlreadyFetched = true;
      state.error = payload.error;
    },
    triggerAuthFailureNavigation: state => {
      state.shouldNavigateToAuthFailure = true;
    },
    clearAuthFailureNavigation: state => {
      state.shouldNavigateToAuthFailure = false;
    },
  },
});

const { actions, reducer } = appStateSlice;

export const {
  fetchInitialDataRequest,
  fetchInitialDataSuccess,
  fetchInitialDataError,
  triggerAuthFailureNavigation,
  clearAuthFailureNavigation,
} = actions;

export default reducer;
